module.exports = __webpack_public_path__ + "static/cusLogo-9245cb965f83438f30fc1d43c6add937.png";